import * as Yup from 'yup';

import i18n from '@/i18n';
import { CustomAttributeTemplate } from '@/types';

export const dynamicValidationSchema = (
  customAttributeTemplates: CustomAttributeTemplate[],
  textToggle: boolean,
  musicToggle: boolean
) => {
  const schemaFields: Record<string, Yup.StringSchema | Yup.NumberSchema> = {
    name: Yup.string()
      .required(i18n.t('nameRequired', { ns: 'common' }))
      .min(2, i18n.t('nameMin', { ns: 'common' }))
      .max(50, i18n.t('nameMax', { ns: 'common' }))
      .test('ascii-test', i18n.t('specialCharsNotAllowed', { ns: 'common' }), function (value) {
        // eslint-disable-next-line no-control-regex
        const asciiRegex = /^[\x00-\x7F]*$/;
        return asciiRegex.test(value ?? '');
      })
  };

  if (textToggle) {
    customAttributeTemplates?.forEach((at) => {
      const match = at.validationRegex?.match(/\.\{(\d+),(\d+)\}/);
      let fieldValidation = Yup.string().max(
        match ? Number(match?.[2]) : 35,
        i18n.t('maxChar', { size: match ? Number(match?.[2]) : 35, ns: 'common' })
      );

      if (Number(match?.[1]) > 0) {
        fieldValidation = fieldValidation.required(i18n.t('minChar', { ns: 'common' }));
      }
      if (at.validationRegex) {
        fieldValidation = fieldValidation.test(
          'regex-test',
          i18n.t('invalidFormat', { ns: 'common' }),
          function (value) {
            const regex = new RegExp(at.validationRegex ?? '');
            return regex.test(value ?? '');
          }
        );
      }

      schemaFields[at.id] = fieldValidation;
    });
  }

  if (!musicToggle) {
    schemaFields['duration'] = Yup.number()
      .required(i18n.t('durationRequired', { ns: 'common' }))
      .moreThan(4, i18n.t('durationMustGreatherThanFive', { ns: 'common' }));
  }

  return Yup.object().shape(schemaFields);
};
